export default __webpack_public_path__ + "static/media/Poppins-Light.27d899b2.woff";